module.exports = __webpack_public_path__ + "static/media/liveroom-other-income-icon .638cd8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/liveroom-other-income-icon .png
// module id = 2069
// module chunks = 6